// import React from "react";
// import { FormGroup, Input, Button, Form } from "reactstrap";

// import { Image, Select } from "antd";
// const { Option } = Select;
// const AddSubCategory = ({
//                        SubCategory,
//                        setSubCategory,
//                        addcategory,
//                        statusupdate,
//                        updatecategory,
//                        setFilter,
//                        allfilter,
//                        filterids,
//                        handleImage,
//                        thumbnail,
//                        allCategory,
//                        category,
//                        setCategory
// }) => {
//   const handleFilter = (val) => {
//     const value = [];
//     for (let title of val) {
//       value.push(title);
//       setFilter(value);
//     }
//   };
//   return (
//     <>
//       <Form role="form">
//         <FormGroup>
//           <label className="form-control-label" htmlFor="name">
//             Enter Sub Category name
//           </label>
//           <Input
//             className="form-control-alternative"
//             id="name"
//             placeholder="Sub Category name"
//             type="text"
//             value={SubCategory}
//             onChange={(e) => setSubCategory(e.target.value)}
//           />
//         </FormGroup>
//         <FormGroup>
//                       <label className="form-control-label d-block" htmlFor="paid">
//                         Select Category
//                       </label>
//                       <Input
//                         type="select"
//                         id="paid"
//                         value={category}
//                         className="form-control-alternative"
//                         onChange={(e) => setCategory(e.target.value)}
//                         required
//                       >
//                         <option value="">Select ... </option>
//                         {allCategory &&
//                           allCategory.map((item) => (
//                             <option key={item._id} value={item._id}>
//                               {item.category}{" "}
//                             </option>
//                           ))}
//                       </Input>
//                     </FormGroup>
//         <FormGroup>
//           <label className="form-control-label d-block" htmlFor="filter">
//             Select Filter
//           </label>
//           <Select
//             showSearch
//             mode="multiple"
//             allowClear
//             value={filterids}
//             style={{ width: "100%" }}
//             placeholder="Select Filter..."
//             optionFilterProp="children"
//             filterOption={(input, option) =>
//               option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//             }
//             onChange={handleFilter}
//           >
//             {allfilter &&
//               allfilter.map((item) => (
//                 <Option value={item._id} key={item._id}>
//                   {item.title}
//                 </Option>
//               ))}
//           </Select>
//         </FormGroup>
//         <FormGroup>
//           <label className="form-control-label" htmlFor="icons">
//             Sub Category Featured Image
//           </label>
//           <Input className="form-control-alternative" id="icons" type="file" accept="image/*" onChange={handleImage} />
//           {thumbnail && <Image width={200} src={thumbnail} className="mt-3" />}
//         </FormGroup>
//         {statusupdate ? (
//           <Button
//             className="my-4 btn-block"
//             type="submit"
//             color="primary"
//             onClick={updatecategory}
//           >
//             Update Sub Category
//           </Button>
//         ) : (
//           <Button
//             className="my-4 btn-block"
//             type="submit"
//             color="primary"
//             onClick={addcategory}
//           >
//             Add Sub Category
//           </Button>
//         )}
//       </Form>
//     </>
//   );
// };
// export default AddSubCategory;


import React from "react";
import { FormGroup, Input, Button, Form } from "reactstrap";
import { Image, Select } from "antd";
const { Option } = Select;

const AddSubCategory = ({
  SubCategory,
  setSubCategory,
  addcategory,
  statusupdate,
  updatecategory,
  setFilter,
  allfilter,
  filterids,
  handleImage,
  thumbnail,
  allCategory,
  category,
  setCategory
}) => {

  const handleFilter = (val) => {
    setFilter(val); // AntD select में सीधे array of _id store करो
  };

  return (
    <>
      <Form role="form">
        <FormGroup>
          <label className="form-control-label" htmlFor="name">
            Enter Sub Category name
          </label>
          <Input
            className="form-control-alternative"
            id="name"
            placeholder="Sub Category name"
            type="text"
            value={SubCategory}
            onChange={(e) => setSubCategory(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <label className="form-control-label d-block" htmlFor="category">
            Select Category
          </label>
          <Input
            type="select"
            id="category"
            value={category}
            className="form-control-alternative"
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Select ... </option>
            {allCategory && allCategory.map((item) => (
              <option key={item._id} value={item._id}>
                {item.category}
              </option>
            ))}
          </Input>
        </FormGroup>

        <FormGroup>
          <label className="form-control-label d-block" htmlFor="filter">
            Select Filter
          </label>
          <Select
            showSearch
            mode="multiple"
            allowClear
            value={filterids}
            style={{ width: "100%" }}
            placeholder="Select Filter..."
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleFilter}
          >
            {allfilter && allfilter.map((item) => (
              <Option value={item._id} key={item._id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="icons">
            Sub Category Featured Image
          </label>
          <Input
            className="form-control-alternative"
            id="icons"
            type="file"
            accept="image/*"
            onChange={handleImage}
          />
          {thumbnail && <Image width={200} src={thumbnail} className="mt-3" />}
        </FormGroup>

        {statusupdate ? (
          <Button
            className="my-4 btn-block"
            type="submit"
            color="primary"
            onClick={updatecategory}
          >
            Update Sub Category
          </Button>
        ) : (
          <Button
            className="my-4 btn-block"
            type="submit"
            color="primary"
            onClick={addcategory}
          >
            Add Sub Category
          </Button>
        )}
      </Form>
    </>
  );
};

export default AddSubCategory;
